import React from 'react';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import Button from '../../../button/v2/button';
import { HStack } from '../../../layouts/stack.layout';
import Heading from '../../../typography/v2/heading';

type HeaderVariant = 'modal' | 'info-card';
type HeaderStylesType = { [key in HeaderVariant]: string };

type Props = {
  close: Function;
  title: string;
  variant?: HeaderVariant;
  buttonIcon?: 'close' | 'back';
};

const styles: HeaderStylesType = {
  modal: 'items-center mobile:px-2 tablet-lg:px-5',
  'info-card':
    'absolute w-full mobile:px-3 tablet-lg:px-5 py-3 border-b border-dark-gray bg-[#171718]/50 backdrop-blur-lg py-3 items-center',
};

export default function HeaderInfoCard({
  close,
  title,
  variant,
  buttonIcon,
}: Props) {
  const { isMobile, isTabletLg } = useBreakpoints();
  return (
    <HStack extensions={styles[variant || 'info-card']} gap="base">
      <Button
        onClick={close}
        asIcon={isMobile && !isTabletLg ? 'back' : buttonIcon || 'close'}
        withButtonStyle={isMobile && !isTabletLg ? true : false}
        color="glass"
        size="sm"
      />
      <Heading variant="secondary">{title}</Heading>
    </HStack>
  );
}
